// extracted by mini-css-extract-plugin
export default {"root":"EditForm_root__aaM5w","form":"EditForm_form__xqor4","after":"EditForm_after__22aM1"};